var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28797 10.2132L10.6013 8.89987L12.7413 6.75987C13.188 6.30654 12.868 5.5332 12.228 5.5332H8.07463L4.33463 5.5332C3.69463 5.5332 3.37463 6.30654 3.82797 6.75987L7.2813 10.2132C7.82797 10.7665 8.73463 10.7665 9.28797 10.2132Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownOpened);
export default __webpack_public_path__ + "static/media/dropdown_opened.efbc57176d36bd1976302198fc39c511.svg";
export { ForwardRef as ReactComponent };